module.exports = __webpack_public_path__ + "static/media/14.84dd86c3.svg";